var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('link-button',_vm._g({attrs:{"aria-expanded":_vm.isFormOpen.toString(),"padded":""}},_vm.$listeners),[_vm._v("\n\tNotify Me When In Stock\n\t"),_c('icon',{attrs:{"name":`chevron-${_vm.isFormOpen ? 'up' : 'down'}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }